import { render, staticRenderFns } from "./forms.vue?vue&type=template&id=449ae47e&scoped=true"
import script from "./forms.vue?vue&type=script&lang=js"
export * from "./forms.vue?vue&type=script&lang=js"
import style0 from "./forms.vue?vue&type=style&index=0&id=449ae47e&prod&lang=scss"
import style1 from "./forms.vue?vue&type=style&index=1&id=449ae47e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449ae47e",
  null
  
)

export default component.exports